import { SiteSettings } from 'src/scripts/utils/environment';

const API_GATEWAY_STAGE_HEADER = 'alo-apigateway-stage';
const STAGING_GATEWAY_STAGE = 'staging' as const;

type ApiGatewayStageType = typeof STAGING_GATEWAY_STAGE;
type ApiGatewayStageHeader = {
  [API_GATEWAY_STAGE_HEADER]?: ApiGatewayStageType;
};

const getApiGatewayStageHeader = (isEnabled: boolean): ApiGatewayStageHeader => {
  if (!isEnabled) {
    return {};
  }
  return { [API_GATEWAY_STAGE_HEADER]: STAGING_GATEWAY_STAGE };
};

export const getAloApiStageHeader = (): ApiGatewayStageHeader =>
  getApiGatewayStageHeader(Boolean(SiteSettings?.enableAloApiGatewayStage));

export const getProductServiceStageHeader = (): ApiGatewayStageHeader =>
  getApiGatewayStageHeader(Boolean(SiteSettings?.enableProductServiceGatewayStage));
